//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'
// import returnCitySN from 'returnCitySN'
export default {
  data () {
    return {
      xrCustomePicture: false
    }
  },
  methods: {
    deletePicture () {
      this.xrCustomePicture = false
    },
    xrCustom () {
      // window.open('http://www.baidu.com/', '_blank')
      this.$router.push('/hospitalPacs')
    }
    // downloadPoint () {
    //   var params = { ip: returnCitySN.cip, type: '1' }
    //   var json = JSON.stringify(params)
    //   params = 'params=' + btoa(unescape(encodeURIComponent(json)))
    //   $.ajax({
    //     // url: 'https://tapi.radida.com/osp/originalDataCollection/download', // 开发地址
    //     url: 'https://apis.radida.com/osp/originalDataCollection/download', // 正式地址
    //     type: 'GET',
    //     data: params,
    //     success: function (data) {
    //       console.log('成功')
    //     } })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/index.vue